import { AppDispatch } from 'app/store';
import { setNameInConflict, setSaveButtonEnabled } from 'common/components/EditDrawer/editDrawerSlice';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { useSnackbar } from 'notistack';

import { DEFAULT_ERROR_MESSAGE } from './errorHandlers';

export const CLAIM_VALUE_FORMAT_ERROR_MESSAGE = 'The Claim value is in an incorrect format. Please update.';
export const CLAIM_VALUE_NOT_CHANGED_ERROR_MESSAGE = 'The Claim value was not changed';

type EnqueueSnackbarFn = ReturnType<typeof useSnackbar>['enqueueSnackbar'];

interface ClaimCreateFailureHandlerOptions {
    dispatch: AppDispatch;
    enqueueSnackbar: EnqueueSnackbarFn;
    entityType: 'User' | 'Role' | 'Claim';
}

interface ClaimEditFailureHandlerOptions {
    dispatch: AppDispatch;
    enqueueSnackbar: EnqueueSnackbarFn;
    setValueInConflict: (value: boolean) => void;
}

export function handleClaimCreateFailure(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: any,
    { dispatch, enqueueSnackbar, entityType }: ClaimCreateFailureHandlerOptions
): void {
    dispatch(setNameInConflict(false));
    switch (extractStatusCode(error.message)) {
        case 400: {
            enqueueSnackbar(CLAIM_VALUE_FORMAT_ERROR_MESSAGE, { variant: 'error' });
            break;
        }
        case 409: {
            dispatch(setNameInConflict(true));
            break;
        }
        default: {
            enqueueSnackbar(
                `There was an error while linking the ${entityType}.` + DEFAULT_ERROR_MESSAGE,
                { variant: 'error' }
            );
            break;
        }
    }
}

export function handleClaimEditFailure(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: any,
    { dispatch, enqueueSnackbar, setValueInConflict }: ClaimEditFailureHandlerOptions
): void {
    if (extractStatusCode(error.message) === 409) {
        setValueInConflict(true);
        dispatch(setSaveButtonEnabled(false));
    } else {
        enqueueSnackbar(
            'There was an error while editing the Claim.' + DEFAULT_ERROR_MESSAGE,
            { variant: 'error' }
        );
    }
}
